import React from 'react';

export type ValidationErrors = {
    [key: PropertyKey]: string[];
};

function ErrorsBox({ errors }: Readonly<{ errors: ValidationErrors }>) {
    return (
        <div className="box red-box">
            {Object.keys(errors).map((key) => {
                return errors[key].map((message, i) => <p key={`${key}${i + 1}`}>{message}</p>);
            })}
        </div>
    );
}

export default ErrorsBox;
